import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '@environments/environment';
import { User } from '@app/_models';
import { MatDialog } from '@angular/material/dialog';
import { CommonUtility } from '@app/_modules/commonUtility';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({ providedIn: 'root' })
export class PaymentService {
    private userSubject: BehaviorSubject<User>;
    public user: Observable<User>;
    Base_url;
    commonUtility:CommonUtility;
    isgPay_url;
    constructor(
        private router: Router,
        private http: HttpClient,
        private snackBar: MatSnackBar,
    ) {
      this.Base_url = environment.Base_url;
      this.isgPay_url =environment.isgPayUrl;
      this.commonUtility = new CommonUtility(snackBar);
    }
    fetchByContractNoandPanNo(req){
      let headers = new HttpHeaders({
        'Content-Type' : 'application/json',
      });
      let url = `${this.Base_url}jpmcservice/fetchByContractNoandPanNo`;
      return this.http.post<any>(url,req,{
        headers : headers,
        observe:'response'
      })
    }

    fetchByContractNo(req){
      let headers = new HttpHeaders({
        'Content-Type' : 'application/json',
      });
      let url = `${this.Base_url}jpmcservice/fetchByContractNo`;
      return this.http.post<any>(url,req,{
        headers : headers,
        observe:'response'
      })
    }

    updateStudentDetail(req){
      let headers = new HttpHeaders({
        'Content-Type' : 'application/json',
      });
      let url = `${this.Base_url}jpmcservice/updateStudentDetail`;
      return this.http.post<any>(url,req,{
        headers : headers,
        observe:'response'
      })
    }
    captureBmwResponse(req){
      let headers = new HttpHeaders({
        'Content-Type' : 'application/json',
      });
      let url = `${this.Base_url}jpmcservice/captureBmwResponse`;
      return this.http.post<any>(url,req,{
        headers : headers,
        observe:'response'
      })
    }
    downloadBmwReceipt(req)
    {  let headers = new HttpHeaders( {
      'Content-Type': 'application/json',
      'Accept': 'application/octet-stream',
      'timeout':  `${999999}`
  });
    let url = `${this.Base_url}jpmcservice/downloadBmwReceipt`;
    return this.http.post(url,req,
      { headers,responseType: 'blob',
      reportProgress: true,
      observe: 'response',       }
    );
  }

  downloadTrimbleTxnReceipt(req)
  {  let headers = new HttpHeaders( {
    'Content-Type': 'application/json',
    'Accept': 'application/octet-stream',
    'timeout':  `${999999}`
});
  let url = `${this.Base_url}jpmcservice/downloadTrimbleTxnReceipt`;
  return this.http.post(url,req,
    { headers,responseType: 'blob',
    reportProgress: true,
    observe: 'response',       }
  );
}


captureQrResponse(req){
  let headers = new HttpHeaders({
    'Content-Type' : 'application/json',
  });
  let url = `${this.Base_url}jpmcservice/captureQrResponse`;
  return this.http.post<any>(url,req,{
    headers : headers,
    observe:'response'
  })
}


downloadQrTxnReceipt(req)
  {  let headers = new HttpHeaders( {
    'Content-Type': 'application/json',
    'Accept': 'application/octet-stream',
    'timeout':  `${999999}`
});
  let url = `${this.Base_url}jpmcservice/downloadQrTxnReceipt`;
  return this.http.post(url,req,
    { headers,responseType: 'blob',
    reportProgress: true,
    observe: 'response',       }
  );
}

downloadBenzReceipt(req)
  {  let headers = new HttpHeaders( {
    'Content-Type': 'application/json',
    'Accept': 'application/octet-stream',
    'timeout':  `${999999}`
});
  let url = `${this.Base_url}jpmcservice/downloadBenzReceipt`;
  return this.http.post(url,req,
    { headers,responseType: 'blob',
    reportProgress: true,
    observe: 'response',       }
  );
}
}
